<h2 mat-dialog-title>Relacionamento</h2>

<div mat-dialog-content>
    <div fxLayout="column wrap">
        <div fxFlex.gt-sm="100%">
            <strong>Ação:</strong> {{data.dados.acao.nome}}
        </div>
        <div fxFlex.gt-sm="100%">
            <strong>Data Operação:</strong> {{data.dados.data_hora_operacao | date:'dd/MM/yyyy HH:mm:ss'}}
        </div>
        <div fxFlex.gt-sm="100%">
            <strong>Observação:</strong> {{data.dados.observacao}}
        </div>

        <div fxFlex.gt-sm="100%" style="margin-top: 10px;" *ngIf="data.dados.atividade_cliente_id !=null ">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>Resposta da Atividade</mat-card-title>
                    <mat-card-subtitle>
                        <span>Assunto: {{ data.dados.atividade_cliente.atividade.assunto.nome }}</span><br />
                        <span>Data:  {{data.dados.atividade_cliente.data_hora_atividade | date:'dd/MM/yyyy'}}</span>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <p>Observacao: {{data.dados.atividade_cliente.atividade.observacao}}</p>
                </mat-card-content>
            </mat-card>
        </div>
       
    </div>
</div>
<br>
<div mat-dialog-actions>
    <button
        mat-button
        tabindex="2"
        (click)="onNoClick()">
        Fechar
    </button>
</div>